import { io } from 'socket.io-client';
import { API_URL } from '../config';

const SOCKET_URL = (API_URL || '').replace(/\/api\/?$/, '');

const socket = io(SOCKET_URL, {
    autoConnect: false,
    reconnection: true,
    auth: {
        token: localStorage.getItem('zTaskAuthToken') || '',
    },
});

// Refresh token before connect in case login happened after module load
socket.on('connect_error', () => {
    socket.auth = { token: localStorage.getItem('zTaskAuthToken') || '' };
});

export const connectSocket = () => {
    socket.auth = { token: localStorage.getItem('zTaskAuthToken') || '' };
    if (!socket.connected) {
        socket.connect();
    }
};

export default socket;
